<template>
  <div>
    <div class="block">
      <div class="block-header">
        <h3 class="block-title"><i class="fas fa-coins"></i> {{ $t('payments.index') }}</h3>
      </div>
      <table class="table table-hover table-sm">
        <thead>
          <th>#</th>
          <th>{{ $t('debts.number') }}</th>
          <th>{{ $t('payments.amount') }}</th>
          <th>{{ $t('payments.payment_date') }}</th>
          <th>{{ $t('options.status') }}</th>
          <th>{{ $t('app.action') }}</th>
        </thead>
        <tbody>
          <tr v-for="(payment, index) in payments" v-if="!isProcessing">
            <td>{{index+1}}</td>
            <td>{{payment.debt.number}}</td>
            <td>{{payment.amount}}</td>
            <td>{{payment.payment_date | dateFormat}}</td>
            <td>{{payment.confirmed ? $t('payments.confirmed') : $t('payments.not_confirmed') }}</td>
            <td>
              <div class="btn-group">
                <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm d-inline">
                  <i class="fa fa-edit"></i>
                </button>
                <button @click.prevent="handleDelete(payment.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" >
                  <i class="fa fa-times-circle"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="isProcessing">
            <td colspan="6" class="text-center">
              <div class='sk-wave'>
                <div class='sk-rect sk-rect-1'></div>
                <div class='sk-rect sk-rect-2'></div>
                <div class='sk-rect sk-rect-3'></div>
                <div class='sk-rect sk-rect-4'></div>
                <div class='sk-rect sk-rect-5'></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      id="updatepayment"
      size="lg"
      :title="$t('payments.edit')"
      ref="modalUpdatePayment"
      @ok="handleUpdate"
      :ok-title="$t('buttons.ok')"
      :cancel-title="$t('buttons.cancel')"
      @ok-disabled="isProcessing"
    >
      <div class="form-group">
        <label class="col-form-label">{{ $t('debts.number') }}</label>
        <label class="form-control">{{debt.number}}</label>
      </div>
      <div class="form-group">
        <label for="UpdateAmount" class="col-form-label">{{ $t('payments.amount') }}</label>
        <input type="text" class="form-control" :class="{'is-invalid': update_errors.amount }" id="UpdateAmount" v-model="update_payment.amount" >
        <span v-if="update_errors.amount" class="invalid-feedback">
          <strong>{{update_errors.amount ? update_errors.amount[0] : ''}}</strong>
        </span>
      </div>
      <div class="form-group">
        <label for="UpdateDate" class="col-form-label">{{ $t('payments.payment_date') }}</label>
        <input type="date" class="form-control" :class="{'is-invalid': update_errors.payment_date }" id="UpdateDate" v-model="update_payment.payment_date" >
        <span v-if="update_errors.payment_date" class="invalid-feedback">
          <strong>{{update_errors.payment_date ? update_errors.payment_date[0] : ''}}</strong>
        </span>
      </div>
      <div class="form-group">
        <label for="StoreStatus" class="col-form-label">{{ $t('options.status') }}</label>
        <select v-model="update_payment.confirmed" class="form-control" id="StoreType">
          <option value="1">{{ $t('payments.confirmed') }}</option>
          <option value="0">{{ $t('payments.not_confirmed') }}</option>
        </select>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payments: [],
      payment: {
        amount: 0,
        payment_date: '',
        confirmed: ''
      },
      update_payment: {},
      debt: {},
      errors: {},
      update_errors: {},
      message: '',
      isProcessing: false,
    };
  },
  mounted() {
    this.fetchPayments();
  },
  methods: {
    fetchPayments() {
      this.isProcessing = true;
      axios.get(`/admin/debtors/${this.$route.params.id}/payments`)
        .then((res) => {
          this.payments = res.data.payments;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearModal() {
      this.payment = {};
      this.errors = {};
    },

    clearUpdateModal() {
      this.update_payment = {};
      this.update_errors = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.$refs.modalUpdatePayment.show();
      this.update_payment = this.payments[index];
      this.debt = this.payments[index].debt;
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updatePayment();
      this.isProcessing = true;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deletePayment(id);
        }
      });
    },

    updatePayment() {
      axios.put(`/admin/debtors/payments/${this.update_payment.id}`, this.update_payment)
        .then((res) => {
          if (res.status === 200){
              this.$refs.modalUpdatePayment.hide();
              this.clearUpdateModal();
              window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
              this.fetchPayments();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deletePayment(id) {
      this.isProcessing = true;
      axios.delete(`/admin/debtors/payments/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchPayments();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
